import React, { useEffect } from 'react'
import { EmptyContainer } from './styles'
import { InfantTimelineView } from '../InfantTimelineView'
import { useMaternalInfantHealthProcedures, usePatient } from '~/context'
import { IHealthProcedures, IPatient } from '~/interfaces'
import { Loader, NotFound } from '~/components/shared/medicalViews'
import { getTimestamp, hasObjectValue } from '~/utils'

import { CreateHealthProcedureDetails } from '~/components/healthProcedures/CreateHealthProcedureDetails'

export const Content = (): JSX.Element => {
  const { patient } = usePatient()
  const {
    sidePanelEvents,
    isLoadingTimeline,
    modalHealthProcedure,
    selectedPregnancy,
    gestationHealthProcedures,
    handleSelectedModalHealthProcedures,
    getBabyHealthProcedures,
    getMotherHealthProcedures
  } = useMaternalInfantHealthProcedures()

  useEffect(() => {
    if (selectedPregnancy.mother) {
      const queryParams = selectedPregnancy.pregnancyId ? { pregnancyId: String(selectedPregnancy.pregnancyId) } : {}
      getMotherHealthProcedures({ pathParams: { patientId: selectedPregnancy.mother.id }, queryParams })
    }
  }, [getMotherHealthProcedures, selectedPregnancy])

  useEffect(() => {
    const hasPatient = hasObjectValue({ ...patient })
    const hasSelectedPregnancy = hasObjectValue({ ...selectedPregnancy })

    if (hasPatient && hasSelectedPregnancy) {
      const queryParams = selectedPregnancy.pregnancyId ? { pregnancyId: String(selectedPregnancy.pregnancyId) } : {}
      getBabyHealthProcedures({ pathParams: { patientId: patient.id }, queryParams })
    }
  }, [gestationHealthProcedures, getBabyHealthProcedures, patient, patient.id, selectedPregnancy])

  const hasData = (): boolean => {
    return sidePanelEvents && sidePanelEvents.length > 0
  }

  const isFirstFetchOfHealthProcedures = (): boolean => {
    return isLoadingTimeline && !hasData()
  }

  const getPatientIdOfHealthProcedure = (patient: IPatient, selectedHealthProcedure: IHealthProcedures): number => {
    const isHealthProcedureInGestationPeriod =
      getTimestamp(selectedHealthProcedure.startDate) <= getTimestamp(selectedPregnancy.endDate)
    if (isHealthProcedureInGestationPeriod) return selectedPregnancy?.mother?.id as number
    return patient.id
  }

  if (isFirstFetchOfHealthProcedures()) {
    return (
      <EmptyContainer>
        <Loader />
      </EmptyContainer>
    )
  }

  if (!hasData()) {
    return (
      <EmptyContainer>
        <NotFound />
      </EmptyContainer>
    )
  }

  return (
    <>
      <InfantTimelineView motherPatient={selectedPregnancy?.mother as IPatient} childPatient={patient} />

      <CreateHealthProcedureDetails
        handleSelectedModalHealthProcedures={() => handleSelectedModalHealthProcedures(null)}
        selectedPatient={() => getPatientIdOfHealthProcedure(patient, modalHealthProcedure as IHealthProcedures)}
        modalHealthProcedure={modalHealthProcedure}
      />
    </>
  )
}
